export default {"src":"/_next/static/image/public/images/ic_phone_grey.a79e1d3579a1c6000c13c6e1f72a0525.svg","height":40,"width":40};